<div class="aw-dialog">
  <div class="aw-dialog-header">Manage Members of {{selectedGroup.name}}</div>
  <div class="aw-dialog-sub-header">Authorize user(s) to be part of this group.</div>

  <!-- Awair Tab -->
  <awair-tab-group style="margin: 0 -32px 32px -32px; padding: 16px 32px;"
                   [selectedTabIndex]="selectedTabIndex"
                   (selectTabIndex)="tabSelected($event)">

    <awair-tab [title]="'Members'">
      <!-- Selected Group Members -->
      <ul class="aw-lg-list" *ngIf="orgOwner != null" awairScrollPrevent>
        <li class="aw-lg-list-item" *ngFor="let selectedGroupMember of selectedGroupMemberList; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%">
            <div class="aw-lg-list-item__main"
              [style.color]="selectedGroupMember.isChecked ? '#495056' : '#868D94'">{{selectedGroupMember.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              {{selectedGroupMember.firstName}} {{selectedGroupMember.lastName}}
            </div>
          </div>
          <div class="float-right flex-row" style="height: 40px">
            <div class="aw-lg-list-item__tail">
              {{selectedGroupMember.deviceListLength}}
              <span *ngIf="selectedGroupMember.deviceListLength < 2">Device</span>
              <span *ngIf="selectedGroupMember.deviceListLength > 1">Devices</span>
            </div>
            <awair-add-toggle
              [isAdded]="selectedGroupMember.isChecked"
              (toggle)="toggleSelectedGroupMember($event, i)">
            </awair-add-toggle>
          </div>
        </li>
      </ul>
      <!-- /.Selected Group Members -->
    </awair-tab>
    <awair-tab [title]="'Others'">
      <!-- Other Group Members -->
      <ul class="aw-lg-list" *ngIf="orgOwner != null" awairScrollPrevent>
        <!-- Active other group members -->
        <li class="aw-lg-list-item" *ngFor="let otherGroupMember of otherGroupMemberList; let i = index">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main"
              [style.color]="otherGroupMember.isChecked ? '#495056' : '#868D94'">{{otherGroupMember.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              {{otherGroupMember.firstName}} {{otherGroupMember.lastName}}
            </div>
          </div>
          <div class="float-right flex-row" style="height: 40px; max-width: 80%">
            <awair-add-toggle
              [isAdded]="otherGroupMember.isChecked"
              (toggle)="toggleOtherGroupMember($event, i)">
            </awair-add-toggle>
          </div>
        </li>
        <!-- /.Active other group members -->

        <!-- Pending members -->
        <li class="aw-lg-list-item--blur" *ngFor="let pendingOrgMember of pendingOrgMemberList; let i = index">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main--blur">{{pendingOrgMember.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              Pending
            </div>
          </div>
        </li>
        <!-- /.Pending members -->
      </ul>
      <!-- /.Other Group Members -->
    </awair-tab>
    <awair-tab [title]="'Invite'">
      <!-- Invitees -->
      <ul class="aw-lg-list" *ngIf="orgOwner != null" awairScrollPrevent>
        <li class="aw-lg-list-item" *ngFor="let invitee of inviteeList; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%">
            <div class="aw-lg-list-item__main">{{invitee}}</div>
            <div class="aw-lg-list-item__sub">Invite</div>
          </div>
          <div class="float-right flex-row" style="height: 40px">
            <img class="aw-lg-list-item__tail-ico aw-cursor-pointer" src="assets/images/invite/ic_cancel.svg"
              (click)="removeInvitee(invitee)">
          </div>
        </li>
      </ul>
      <!-- /.Invitees -->
    </awair-tab>
  </awair-tab-group>
  <!-- /.Awair Tab -->

  <!-- Invite members -->
  <h3 class="aw-section-header" style="margin-bottom: 8px;">Invite Members</h3>
  <awair-invite-input
    style="display: block; margin-bottom: 4px;"
    [inviteeList]="inviteeList"
    [orgUserList]="orgUserList"
    [pendingMemberList]="pendingOrgMemberList"
    (add)="addInvitee($event)">
  </awair-invite-input>
  <!-- /.Invite members -->

  <div class="counter-container" style="margin-bottom: 32px;">
    <p class="counter" *ngIf="removeCtr > 0">Removing: {{removeCtr}}</p>
    <p class="counter" *ngIf="addCtr > 0">Inviting: {{addCtr}}</p>
  </div>

  <div class="btn-set">
    <button class="aw-btn aw-btn-gray" style="margin-right: 8px;" (click)="onClose()">Close</button>
    <button class="aw-btn aw-btn-blue" (click)="onSave()" [disabled]="(addCtr === 0 && removeCtr === 0) || isLoading">Save</button>
  </div>
</div>
